import '../assets/styles/index.scss';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';

// ── Page ──────────────────────────────────────────────────────
function Home() {
  useEffect(() => {
    const elements = document.querySelectorAll('.animate-on-load');
    elements.forEach((el, index) => {
      setTimeout(() => el.classList.add('animate-in'), index * 130);
    });
  }, []);

  return (
    <div className="Home">

      {/* ─── Hero ─────────────────────────────────────────── */}
      <section className="hero-section">
        <div className="wd-8 w-100">
          <div className="row align-items-center g-0">

            {/* Left — text */}
            <div className="col-lg-12 text-center">
              <div className="hero-greeting animate-on-load">
                <span className="greeting-text">Hello, I'm</span>
              </div>

              <h1 className="hero-title animate-on-load">
                <span className="name-highlight">INIOBONG PIUS</span>
              </h1>

              <div className="hero-subtitle animate-on-load">
                <span className="role-text">Product Engineer</span>
              </div>

              <div className="hero-cta-wrapper animate-on-load mt-5">
                <Link to="/projects" className="hero-cta">
                  View Projects
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M5 12h14M12 5l7 7-7 7" />
                  </svg>
                </Link>

                <div className="hero-social-divider">
                  <span>or connect with me</span>
                </div>

                <div className="social-links">
                  <a className="social-icon" href="https://www.linkedin.com/in/piusiniobong/" rel="noreferrer" target="_blank" aria-label="LinkedIn">
                    <img width={17} src={require('./../assets/images/linkedin.svg').default} alt="LinkedIn" />
                  </a>
                  <a className="social-icon" href="https://hashnode.com/@pye" rel="noreferrer" target="_blank" aria-label="Hashnode">
                    <img width={17} src={require('./../assets/images/hashnode.svg').default} alt="Hashnode" />
                  </a>
                  <a className="social-icon" href="https://github.com/payose" rel="noreferrer" target="_blank" aria-label="GitHub">
                    <img width={17} src={require('./../assets/images/github.svg').default} alt="GitHub" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ─── About Me ─────────────────────────────────────── */}
      <section className="about-section">
        <div className="wd-8 w-100">
          <div className="row align-items-center g-5">
            <div className="col-lg-5">
              <div className="about-label animate-on-load">About Me</div>
              <h2 className="about-title animate-on-load">
                Product Engineer
              </h2>
            </div>

            <div className="col-lg-7">
              <div className="about-content animate-on-load">
                <p className="about-text">
                  I'm a <strong>Product Engineer</strong> with 6+ years of experience building and evolving products across fintech and SaaS. My work spans the full product lifecycle, from understanding the problem and shaping technical decisions to building, testing, and shipping reliable software at scale.
                </p>
                <p className="about-text">
                  I care about how product decisions become engineering decisions: how requirements shape architecture, how systems evolve as the product grows, and how we build software that remains useful, reliable, and understandable over time.
                </p>
                <p className="about-text mb-0">
                  Beyond shipping products, I care deeply about <strong>developer experience</strong> and the systems, tools, and practices that make engineering teams more effective. I also write about <strong>product engineering, software architecture, developer experience, HCI, and AI</strong>.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
}

export default Home;
